import React from "react";
import ConfigSection from "../../ConfigSection";

const PaymentScheduleSelection = ({ userDetails, selectedClient }) => {
  return (
    <ConfigSection
      title='Payment Schedule'
      configType='PaymentSchedule'
      userDetails={userDetails}
      selectedClient={selectedClient}
      configKey='title'
    />
  );
};

export default PaymentScheduleSelection;
